'use strict';

var assign = require('object-assign');

function ProjectsClient(client) {
  this.client = client;
}

assign(ProjectsClient.prototype, {
  list: function list() {
    return this.client.request({ uri: '/projects' });
  },
  getById: function getById(id) {
    return this.client.request({ uri: '/projects/' + id });
  }
});

module.exports = ProjectsClient;